
import { ProfessionData } from '../types/professionTypes';

export const agroalimentaire: ProfessionData = {
  title: "Agroalimentaire",
  slug: "agroalimentaire",
  description: "Solutions de valorisation des déchets pour l'industrie agroalimentaire",
  icon: "Wheat",
  heroImage: "/lovable-uploads/328f4f86-9058-4b88-b6b8-5bcc727eb914.png",
  wasteMaterials: [
    {
      type: "Déchets organiques",
      description: "Résidus de production, sous-produits alimentaires",
      solutions: ["Compostage industriel", "Méthanisation", "Alimentation animale"],
      environmentalBenefit: "Valorisation énergétique et réduction du gaspillage"
    },
    {
      type: "Emballages alimentaires",
      description: "Cartons, plastiques, films d'emballage",
      solutions: ["Tri à la source", "Recyclage matière", "Valorisation énergétique"],
      environmentalBenefit: "Économie circulaire des emballages"
    },
    {
      type: "Huiles alimentaires usagées",
      description: "Huiles de friture, graisses de cuisson",
      solutions: ["Collecte spécialisée", "Production biocarburant", "Savonnerie"],
      environmentalBenefit: "Évite la pollution des eaux et produit de l'énergie verte"
    }
  ],
  relatedProfessions: ["restaurateur", "boucher", "boulanger"]
};
